import { Injectable } from '@angular/core';
import { ModalService } from '../shared/components/modal/modal.service';
import { Storage } from '@ionic/storage-angular';
import { from, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommercialCommunicationsComponent } from '../shared/components/commercial-communications/commercial-communications.component';
import { AlertService } from '../shared/components/alert/alert.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommercialCommunicationsService {

  public today = new Date().toISOString().split('T')[0];
  //public forceShowModal = true;

  constructor(private alertService: AlertService, private storage: Storage) { }

  getHasToAskForCommunications(): Observable<boolean> {
    return from(this.storage.get('ASKFORCOMMUNICATIONS')).pipe(
      map((val: any) => {
        if (val === null || this.hasMoreThan30Days(val.date)) {
          return true;
        }
        return false;
      })
    );
  }

  private hasMoreThan30Days(savedDateString: string): boolean {
    const savedDate = new Date(savedDateString);
    const today = new Date(this.today);

    const diffInTime = today.getTime() - savedDate.getTime();
    const diffInDays = diffInTime / (1000 * 3600 * 24);

    return diffInDays >= 30;
  }

  async checkToAskForCommunications(profile) {
    this.getHasToAskForCommunications().subscribe(val => {
      if (val === true) {
        const model = { date: this.today };
        this.storage.set('ASKFORCOMMUNICATIONS', model);
        this.askToAcceptCommunications(profile);
      }
    });
  }

  askToAcceptCommunications(profile) {
    this.alertService.showModal(CommercialCommunicationsComponent, { profile: profile }, null).subscribe((modal: any) => {
      modal.getChildComponent().subscribe((componentRef: CommercialCommunicationsComponent) => {
        componentRef.closeModalEvent.subscribe(() => {
          this.alertService.removeModal();
        });
      });
    });
  }

  getHasToAskForWhatsapp(): Observable<boolean> {
    return from(this.storage.get('ASKFORWHATSAPP')).pipe(
      map((val: any) => {
        if (val === null || this.hasMoreThan30Days(val.date)) {
          return true;
        }
        return false;
      })
    );
  }

  async checkToAskForWhatsapp(profile) {
    const check$ = !environment.production ? of(true) : this.getHasToAskForWhatsapp();
    check$.subscribe(val => {
      if (val === true) {
        if (environment.production) {
          this.storage.set('ASKFORWHATSAPP', { date: this.today });
        }
        this.askToAcceptWhatsapp(profile);
      }
    });
  }

  askToAcceptWhatsapp(profile) {
    this.alertService.showModal(CommercialCommunicationsComponent, { profile: profile, initialStep: 'whatsapp' }, null).subscribe((modal: any) => {
      modal.getChildComponent().subscribe((componentRef: CommercialCommunicationsComponent) => {
        componentRef.closeModalEvent.subscribe(() => {
          this.alertService.removeModal();
        });
      });
    });
  }
}
